export default "__VITE_ASSET__7499269e__"